import React, { useEffect } from "react";

interface ButtonProps {
  buttonText?: string | null;
  buttonType?: "button" | "submit" | "reset";
  className?: string;
  icon?: string;
  children?: React.ReactNode;
  buttonSize?: "xs" | "sm" | "md" | "lg";
  buttonWidth?: "xs" | "sm" | "md" | "lg";
  iconPosition?: "left" | "right";
  buttonStyleOutline?: boolean;
  buttonSoft?: boolean;
  buttonStyleRounded?: boolean;
  disabled?: boolean;
  onClick?: (event?: any) => void;
  theme?: any;
  buttonStyleType?:
  | "primary"
  | "light"
  | "success"
  | "info"
  | "warning"
  | "danger"
  | "dark"
  | "link"
  | "secondary";
}
const Button = ({
  buttonText = null,
  buttonType = "submit",
  className,
  children,
  icon,
  buttonSize = "md",
  buttonStyleType,
  buttonStyleOutline = false,
  buttonStyleRounded = false,
  iconPosition = "right",
  buttonSoft = false,
  buttonWidth,
  onClick,
  disabled,
  theme
}: ButtonProps): JSX.Element => {
  const size = `btn-${buttonSize}`;
  const styleType = `btn${buttonStyleOutline ? "-outline-" : "-"
    }${buttonStyleType}`;
  const styleRounded = `btn-${buttonStyleRounded ? "rounded" : ""}`;

  useEffect(() => {
    console.log("theme", theme)
    if (theme) {
      for (const [key, value] of Object.entries(theme)) {
        console.log(`${key}: ${value}`);
        document.documentElement.style.setProperty(`--${key}`, value as string);
      }
    }
  }, [theme])


  return (
    <>
      <button
        onClick={onClick}
        type={buttonType}
        disabled={disabled}
        className={`btn waves-effect waves-light ${size} ${styleType} ${styleRounded} ${className ? className : ""
          } ${buttonSoft ? `btn-soft-${buttonStyleType}` : ""} ${buttonWidth ? `w-${buttonWidth}` : ""
          }`}
      >
        {icon && iconPosition === "left" && (
          <span className="material-symbols-outlined">
            {icon}
          </span>

        )}
        {buttonText && buttonText}
        {children}
        {icon && iconPosition === "right" && (
          <span className="material-symbols-outlined">
            {icon}
          </span>
        )}
      </button>
    </>
  );
};

export default Button;
